import errors from "../../errors";

/**
 * Handles the different scenarios on which the autologin config property can come from the caller. In case it comes
 * in the deprecated way, first a warning will be sent to the console specifying how it should be done instead. After
 * that, the value of the autologin config will be returned.
 * @param {Object} signupData The config object that was passed to the signup function, which can contain the autologin
 * option specified.
 * @param {Boolean} autologin Autologin option is it was passed as a second parameter to signup() function by the
 * caller.
 * @return {Boolean} The value of the autologin property passed to signup function. The preferred way will be used if
 * possible to get the value of the config property, and the deprecated one if the preferred one not present. Default
 * will be true.
 */
export function handleAutologinDeprecation(signupData, autologin) {
  if (autologin === true || autologin === false) {
    console.warn(errors.authentication.signup.AUTOLOGIN_AS_PARAM_DEPRECATED_MESSAGE);
  }
  if (signupData.autologin === true || signupData.autologin === false) {
    return signupData.autologin;
  } else if (autologin === true || autologin === false) {
    return autologin;
  } else {
    return true;
  }
}

/**
 * This function exists to support old versions of the signup function which expected the user email or phone to come in
 * a field called 'user' inside the signupData object. Newer versions expect this field to be called 'username' so this
 * function ensures backwards compatibility. In case the account identifier comes in the field called 'user', it will
 * move it to one called 'username' and will remove the user field from the signupData object.
 * @param {Object} signupData - Configuration object passed to the signup method to perform an account creation.
 * @return {Object} Returns the same signupData received as a parameter but having the account identifier stored in a
 * field called username.
 */
export function normalizeSignupUsernameParam(signupData) {
  if (signupData.user) {
    console.warn(errors.authentication.signup.USER_PARAM_DEPRECATED_MESSAGE);
  }
  signupData.username = signupData.username || signupData.user;
  delete signupData.user;
  return signupData;
}

/**
 * This function exists to support old versions of the login function which expected the user email or phone to come in
 * a field called 'userName' inside the loginData object. Newer versions expect this field to be called 'username' so this
 * function ensures backwards compatibility. In case the account identifier comes in the field called 'userName', it will
 * move it to one called 'username' and will remove the user field from the loginData object.
 * @param {Object} loginData - Configuration object passed to the login method to perform an account creation.
 * @return {Object} Returns the same loginData object received as a parameter but having the account identifier stored in a
 * field called 'username'.
 */
export function normalizeLoginUsernameParam(loginData) {
  if (loginData && loginData.userName) {
    console.warn(errors.authentication.login.USERNAME_PARAM_DEPRECATED_MESSAGE);
    loginData.username = loginData.userName;
    delete loginData.userName;
  }
  return loginData;
}
